import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login, getCompanyList, doLogin } from "../../actions/auth";
import compose from "recompose/compose";
import { Checkbox } from "antd";
import bgIcon from "../../assets/images/login-bg.jpg";
import logoIcon from "../../assets/images/logo.png";
import defaultIcon from "../../assets/images/company.png";
import {
  Grid,
  Typography,
  Avatar,
  InputAdornment,
  TextField,
  Button
} from "@material-ui/core/";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import LockIcon from "@material-ui/icons/Lock";
import { blue } from "@material-ui/core/colors";
import { transform } from "babel-core";
import zIndex from "@material-ui/core/styles/zIndex";

const styles = (theme) => ({
  loginBg: {
    position: 'relative',
    width: "100%",
    height: "100vh",
    background: `url(${bgIcon}) center center / cover`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loginShadow: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    background: 'rgba(226,226,226,.25)',
    zIndex: '1'
  },
  loginBox: {
    position: 'relative',
    width: "460px",
    height: "600px",
    padding: "40px",
    background: "rgba(255,255,255, .8)",
    borderRadius: "8px",
    zIndex: '5'
  },
  loginLogo: {
    width: "100%",
    height: "70px",
    textAlign: "right",
    transform: "translate(10px, -10px)",
    "& img": {
      height: "70px"
    }
  },
  boyingAvatar: {
    width: "60px",
    height: "60px",
    marginTop: "20px"
  },
  boyingText: {
    padding: "0px 20px 30px 70px",
    fontSize: "40px",
    color: blue[700],
    marginTop: "-60px"
  },
  loginText: {
    marginTop: "10px",
    fontSize: "24px",
    lineHeight: "36px",
    color: "#333",
    fontWeight: "600"
  },
  subText: {
    fontSize: "14px",
    lineHeight: "21px"
  },
  companyList: {
    width: "100%",
    maxHeight: "380px",
    overflowY: "auto",
    marginTop: "24px",
  },
  list: {
    width: "100%",
    height: "60px",
    marginBottom: "16px",
    padding: "10px",
    background: "#fff",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    fotnSize: "16px",
    color: "#333",
    fontWeight: "600",
    cursor: "pointer",
    "& img": {
      width: "40px",
      height: "40px",
      marginRight: "16px",
      borderRadius: "50%",
      background: "#eee"
    },
    "&:last-child": {
      marginBottom: "0"
    },
    "&:hover": {
      background: '#e6f7ff'
    }
  },
  loginForm: {
    width: "100%",
    marginTop: "30px"
  },
  inputStyle: {
    width: "100%",
    marginBottom: "30px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderBottom: "1px solid #2b3dcd !important",
      borderRadius: 0
    },
    "& .MuiOutlinedInput-root": {
      paddingLeft: "5px !important"
    }
  },
  forgetPassword: {
    color: blue[600],
    textAlign: "center",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  loginButton: {
    width: "100%",
    marginBottom: "20px",
    height: "50px",
    borderRadius: theme.spacing(4),
    backgroundColor: "#315de3",
    color: "white",
    fontSize: "20px"
  },
  footer: {
    position: 'absolute',
    zIndex: '10',
    left: '0',
    bottom: '0',
    width: '100%',
    height: '30px',
    zIndex: '100',
    textAlign: 'center',
    fontSize: '13px',
    color: '#fff',
    lineHeight: '30px'
  },
  footerName: {
    marginLeft: '20px'
  },
  btnLine: {
    width: "100%",
    marginBottom: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }
});

export class Login extends Component {
  state = {
    username: "",
    password: "",
    usernameError: false,
    passwordError: false,
    checked: false,
    showLogin: true,
    showCompany: false,
    companyList: [ ],
    tokenInfo: {}
  };

  static propTypes = {
    doLogin: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool
  };

  componentDidMount() {
    let username = localStorage.getItem("localeUserName");
    let password = localStorage.getItem("localePassword");
    if (username) {
      this.setState({
        username: username,
        password: password,
        checked: true
      });
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    if (this.state.checked) {
      localStorage.setItem("localeUserName", this.state.username);
      localStorage.setItem("localePassword", this.state.password);
    }
    if (this.state.username.length > 0 && this.state.password.length > 0)
      localStorage.setItem("isModalClose", "0");

    login(this.state.username, this.state.password).then(res => {
      if (res.access) {
        this.setState({
          tokenInfo: res
        })
        // localStorage.setItem("access", res.access);
        // localStorage.setItem("refresh", res.refresh);
        // return
        getCompanyList(res.access).then(resp => {
          let list = resp.result || []
          if (list.length > 1) {
            this.setState({
              showCompany: true,
              showLogin: false,
              companyList: list.map(v => {
                return {
                  ...v.application,
                  ...v.company
                }
              })
            })
          } else if (list.length == 1) {
            let data = list[0]
            let company = data.company ? data.company.company_name : ''
            localStorage.setItem('applicationList', JSON.stringify(this.state.companyList))
            localStorage.setItem('applicationName', data.application.application_name)
            localStorage.setItem('companyName', company)
            this.props.doLogin(true, {
              ...res,
              ...data.application,
            })
          } else {
            this.props.doLogin(false, {detail: 'unBind application'})
          }
        })
      } else {
        this.props.doLogin(false, res.data)
      }
    }).catch(err => {
      this.props.doLogin(false, err.response.data)
    })
    if (this.state.username.length == 0) {
      this.setState({
        usernameError: true
      });
    }
    if (this.state.password.length == 0) {
      this.setState({
        passwordError: true
      });
    }
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  usernameFocus = () => {
    this.setState({
      usernameError: false
    });
  };

  passwordFocus = () => {
    this.setState({
      passwordError: false
    });
  };

  passwordBlur = (e) => {
    if (e.target.value.length < 1)
      this.setState({
        passwordError: true
      });
    else
      this.setState({
        passwordError: false
      });
  };

  changeCheckbox = (e) => {
    this.setState({
      checked: e.target.checked
    });
  };

  chooseApp = (data) => {
    // 保存应用id
    localStorage.setItem('applicationList', JSON.stringify(this.state.companyList))
    localStorage.setItem('applicationName', data.application_name)
    localStorage.setItem('companyName', data.company_name)
    this.props.doLogin(true, {
      ...this.state.tokenInfo,
      application_id: data.application_id,
      index_url: data.index_url,
      application_logo_url: data.application_logo_url,
    })
  }

  render() {
    if (this.props.isAuthenticated) {
      if (this.props.index_url) {
        return <Redirect to={this.props.index_url} />;
      } else {
        return <Redirect to="/" />;
      }
    }
    const classes = this.props.classes;
    return (
      <Fragment>
        <Grid container className={classes.loginBg}>
          <div className={classes.loginShadow}></div>
          <Grid item className={classes.loginBox}>
            <div className={classes.loginLogo}>
              <img src={logoIcon} />
            </div>
            {this.state.showLogin && (
              <>
                <div className={classes.loginText}>登录</div>
                <Grid container>
                  <div className={classes.loginForm}>
                    <div>
                      <TextField
                        error={this.state.usernameError}
                        helperText={
                          this.state.usernameError ? "用户名不能为空" : ""
                        }
                        autoFocus={true}
                        onFocus={this.usernameFocus}
                        fullWidth={true}
                        className={classes.inputStyle}
                        variant="outlined"
                        placeholder="手机号码/用户名/已认证邮箱"
                        onChange={this.onChange}
                        value={this.state.username}
                        name="username"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <PhoneIphoneIcon />
                            </InputAdornment>
                          )
                        }}
                      />
                    </div>
                    <div>
                      <TextField
                        error={this.state.passwordError}
                        helperText={
                          this.state.passwordError ? "密码不能为空" : ""
                        }
                        onBlur={this.passwordBlur}
                        onFocus={this.passwordFocus}
                        className={classes.inputStyle}
                        variant="outlined"
                        placeholder="登录密码"
                        name="password"
                        onChange={this.onChange}
                        value={this.state.password}
                        type="password"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockIcon />
                            </InputAdornment>
                          )
                        }}
                      />
                    </div>
                    <div className={classes.btnLine}>
                      <Checkbox
                        onChange={this.changeCheckbox}
                        checked={this.state.checked}
                      >
                        记住密码
                      </Checkbox>
                    </div>
                  </div>
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth={true}
                      onClick={this.onSubmit}
                      className={classes.loginButton}
                    >
                      登录
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth={true}
                      onClick={() => window.location.replace('https://backend.anwin.co/?sso')}
                      className={classes.loginButton}
                    >
                      SSO登录
                    </Button>
                  </Grid>
                  <Grid item xs={12}></Grid>
                </Grid>
                <div
                  className={classes.forgetPassword}
                  onClick={() => this.props.history.push("/reset")}
                >
                  忘记密码
                </div>
              </>
            )}

            {this.state.showCompany && (
              <>
                <div className={classes.loginText}>欢迎!</div>
                <div className={classes.subText}>
                  您的账号属于多个应用，请选择要登录的应用
                </div>
                <div className={classes.companyList}>
                  {this.state.companyList.map((v, i) => (
                    <div className={classes.list} key={i} onClick={() => this.chooseApp(v)}>
                      <img src={v.application_logo_url || defaultIcon} />
                      {v.application_name}
                    </div>
                  ))}
                </div>
              </>
            )}

          </Grid>
        </Grid>
        <div className={classes.footer}>
          京ICP备2021001914号  
          <span className={classes.footerName}>北京安楹康思医学科技有限公司</span>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  index_url: state.auth.index_url
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, { doLogin })
)(withRouter(Login));
